import actionTypes from '../constants/action-types';

const DEFAULT_STATE = '';

const token = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_TOKEN:
      return action.payload.authToken;
    default:
      return state;
  }
};

export default token;
